// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qp-1";
export var stateContainer = "_qp-0";